(function (rootEnvironment, factory) {
  var api = rootEnvironment && rootEnvironment.NulelaStickyAtc
    ? rootEnvironment.NulelaStickyAtc
    : factory();

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (rootEnvironment) rootEnvironment.NulelaStickyAtc = api;
  if (rootEnvironment && rootEnvironment.document) api.init(rootEnvironment.document);
})(typeof window !== 'undefined' ? window : null, function () {
  var bindings = new WeakMap();

  function applyPurchaseState(bar, detail) {
    if (!bar || !detail) return;
    var variantInput = bar.querySelector('[name="id"]');
    var sellingPlanInput = bar.querySelector('[name="selling_plan"]');
    var price = bar.querySelector('[data-nulela-sticky-price]');
    var compare = bar.querySelector('[data-nulela-sticky-compare]');
    var submit = bar.querySelector('button[type="submit"]');

    if (variantInput && detail.variantId) variantInput.value = String(detail.variantId);
    if (sellingPlanInput) {
      sellingPlanInput.value = detail.sellingPlanId ? String(detail.sellingPlanId) : '';
      sellingPlanInput.disabled = !detail.sellingPlanId;
    }
    if (price) price.textContent = detail.priceLabel || '';
    if (compare) {
      compare.textContent = detail.compareAtPriceLabel || '';
      compare.hidden = !detail.compareAtPriceLabel;
    }
    if (submit) submit.disabled = detail.available === false;
  }

  function init(documentRoot) {
    if (!documentRoot || bindings.has(documentRoot)) return;

    function handlePurchaseState(event) {
      Array.prototype.forEach.call(
        documentRoot.querySelectorAll('[data-nulela-sticky-atc]'),
        function (bar) { applyPurchaseState(bar, event.detail); },
      );
    }

    documentRoot.addEventListener('nulela:purchase-state', handlePurchaseState);
    bindings.set(documentRoot, handlePurchaseState);
  }

  function destroy(documentRoot) {
    var handler = documentRoot && bindings.get(documentRoot);
    if (!handler) return;
    documentRoot.removeEventListener('nulela:purchase-state', handler);
    bindings.delete(documentRoot);
  }

  return {
    applyPurchaseState: applyPurchaseState,
    init: init,
    destroy: destroy,
  };
});
